import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { displayStageLabel } from '@/lib/stageLabels';

export function StageRow({ stage, index, onChange, onDelete, locked }) {
  const id = `s-${index}`;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled: locked });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.8 : 1 };
  return (
    <div ref={setNodeRef} style={style} data-testid="pipeline-stage-item" className="flex items-center gap-3 rounded-xl border bg-card p-3">
      <button {...attributes} {...listeners} disabled={locked} className="cursor-grab active:cursor-grabbing disabled:cursor-not-allowed" aria-label="Drag">
        <GripVertical className="h-4 w-4 text-muted-foreground" />
      </button>
      <span className="rounded-md bg-secondary px-2 py-0.5 font-mono text-[11px] font-medium">
        {displayStageLabel(stage.code)}
      </span>
      <Input value={stage.label} onChange={(e) => onChange({ ...stage, label: e.target.value })} className="max-w-xs" data-testid={`pipeline-stage-label-${index}`} />
      {stage.code === 'PANEL' || stage.code === 'CODE_PANEL' ? (
        <label className="flex items-center gap-2 text-xs text-muted-foreground">
          <Switch checked={stage.code_editor !== false} onCheckedChange={(v) => onChange({ ...stage, code_editor: v })} />
          Code editor
        </label>
      ) : null}
      <span className="ml-auto text-[10px] uppercase tracking-wider text-muted-foreground">{locked ? 'locked' : 'movable'}</span>
      {!locked && stage.code !== 'OFFER' && <Button variant="ghost" size="sm" onClick={onDelete}><Trash2 className="h-4 w-4 text-rose-600" /></Button>}
    </div>
  );
}
